import { render, staticRenderFns } from "./il-language-selection.vue?vue&type=template&id=3612bd52&"
import script from "./il-language-selection.vue?vue&type=script&lang=ts&"
export * from "./il-language-selection.vue?vue&type=script&lang=ts&"
import style0 from "./il-language-selection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports